<template>
  <v-layout v-if="show">
    <v-chart :style="style" :options="charts"/>
  </v-layout>
</template>

<script> 
export default {
  props:["not","notShow","notChartType","notUnit","notHeight","notWidth","notColors","notChartData"],
  data: () => ({
    show:false, 
     
  }),
  mounted() { 
    this.show = false
      setTimeout(() => {
        this.show = this.notShow
      }, 100); 
  },
  computed: {
    vs(){
      return this.not.vs
    },
    vs_width(){
      return this.vs.width
    },
    style(){
      let h = "400px"
      let w = "100%"
      if (this.notWidth) {
        w = this.notWidth
      }
      if (this.notHeight) {
        h=this.notHeight
      }
      return "width: "+w+"; height:"+h+";"
    },
    charts(){ 
      let data =   this.notChartData
      if (this.notUnit==="Percentage") {
        data = this.percentage(data)
      }else if (this.notUnit==="%") {
        data = this.percentage(data)
      }
      let chartData = this.combination(data) 
      let ch = this.processChart(chartData)
      return ch
    }, 

  },
  methods:{
    percentage(data){
      if (!data) {
        return null
      }

      let TOTAL = 0 
      data.forEach(it => {
        TOTAL = TOTAL+(it.value*1)
      });
      data.forEach(it => {
        let t = (it.value*100)/TOTAL
        it.value = t.toFixed(2);
      });
      return data
    },
    processChart(chartData,  toolboxPadding = 550){
      if (!chartData) {return null}  
      let unitValue = this.notChartType==="question"?"q":"Votes"
      let  chart = {
        // Add title
        title: {
            text: '',
            x: 'left',
            textStyle: {
                fontWeight: 100,
                fontSize: 14
            }
        },
        // Add tooltip
        tooltip: {
            trigger: 'item',
            // formatter: "{a} <br/>{b}: {c} ({d}%)"
            formatter: "{a} <br/>{b}:({d}%)"
        },
        // Add legend
        legend: {
            orient: 'horizontal',
            x: 'left',
            y: 'bottom',
            data: chartData.labels,
        },

        grid: {
            width: 'auto'
        },
        color: ['#006180','#f7a823',"#00799f","#fab43e","#0395c4","#f7c167","#04abe0","#f79367","#0cc2fc","#f97e47"],
        // Display toolbox
        toolbox: {
            show: true,
            orient: 'vertical',
            feature: {
                mark: {
                    show: true,
                    title: {
                        mark: 'Markline switch',
                        markUndo: 'Undo markline',
                        markClear: 'Clear markline'
                    }
                },
                dataView: {
                    show: true,
                    readOnly: true,
                    title: 'View data',
                    lang: ['View chart data', 'Close', 'Update']
                },
                magicType: {
                    show: true,
                    title: {
                        pie: 'Switch to pies',
                        funnel: 'Switch to funnel',
                    },
                    type: ['pie', 'funnel'],
                    option: {
                        funnel: {
                            x: '0%',
                            y: '0%',
                            width: '0%',
                            height: '70%',
                            funnelAlign: 'left',
                            max: 1548
                        }
                    }
                },
                restore: {
                    show: true,
                    title: 'Restore'
                },
                saveAsImage: {
                    show: true,
                    title: 'Same as image',
                    lang: ['Save']
                }
            },
            left: "90%"
        },
        // Enable drag recalculate
        calculable: true,
        // Add series
        series: [{
            name: chartData.labels,
            type: 'pie',
            radius: '50%',
            center: ['50%', '50%'],
            data: chartData.collection,
            label: {
                normal: {
                    // formatter: "{b}: {c}\n({d}%)"
                    formatter: "({d}%)"
                }
            }
        }]
      }
      return chart;
    }, 
    combination(chartData){
        if (!chartData) {return null} 
        let labels = []
        chartData.forEach(it => {
          labels.push(it.name)
        }); 
        return {
          labels:labels,
          collection:chartData
        };
    }
  },
  watch: {
    notShow(v){
      this.show =v
    },
    notHeight(v){
      this.show = false
      setTimeout(() => {
        this.show = this.notShow
      }, 100); 
    },
    notChartData(v){ 
      // this.show = false
      // setTimeout(() => {
      //   this.show = this.notShow
      // }, 100); 
    },
    vs_width(v){
      this.show = false
      setTimeout(() => {
        this.show = this.notShow
      }, 100); 
    }
  },
};
</script>
